import { GridCellProps } from '@progress/kendo-react-grid';
import GridCellBase from 'src/components/GridCellBase';
import TextInput from 'src/components/TextInput';
import useDelayedInputOnchange from 'src/hooks/useDelayedInputOnchange';
import { useContextSelector } from 'use-context-selector';
import { InvoiceContext } from '../InvoiceDetailsContext';
import PreviewLineItemSequence, { generatePreviewText } from './PreviewLineItemSequence';

const ItemNumberCell = (props: GridCellProps) => {
  const { dataItem } = props;
  const { showPreview = false, errors = [] } = dataItem;
  const isDisabled = !dataItem.selected;
  const isAppendLineItem = dataItem.appendLineItem;
  const { handleChange, value } = useDelayedInputOnchange(props, true);
  const { numLineItems } = useContextSelector(InvoiceContext, (context) => context);
  const invoiceLineItems = useContextSelector(
    InvoiceContext,
    (context) => context.invoiceLineItems
  );
  const total = invoiceLineItems?.length || 0;

  const title = generatePreviewText(total, numLineItems, value);

  return (
    <GridCellBase
      {...props}
      className={`!bg-transparent`}
      title={showPreview && isAppendLineItem && !isDisabled ? title : value}
    >
      <div className="flex items-center gap-2">
        <span className="text-black">=</span>
        <div className="w-full">
          <TextInput
            type={'text'}
            value={value}
            placeholder={isAppendLineItem ? 'Item 1, Item 2...' : 'Item'}
            onChange={handleChange}
            disabled={isDisabled}
            valid={!errors.length}
          />
        </div>
      </div>
      {showPreview && isAppendLineItem && !isDisabled && (
        <PreviewLineItemSequence itemValue={value} />
      )}
    </GridCellBase>
  );
};

export default ItemNumberCell;
